'use strict';

import axios from 'axios';
// import {Message} from 'element-ui';
import api from '../providers/api';

axios.interceptors.request.use(
  config => {
    // loading
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // let code = error.response.status
    // window.localStorage.setItem('maintenanceTime', JSON.stringify(error.response.data.maintenanceTime))
    // if (code === 403) {
    //   sessionStorage.clear();
    //   let obj = window.location;
    //   let href = obj.origin + obj.pathname + '#/login?status=true';
    //   window.location.href = href;
    // }
    // if (code === 503) {
    //   sessionStorage.clear();
    //   let obj = window.location;
    //   let href = obj.origin + obj.pathname + '#/login?status=maintain';
    //   window.location.href = href;
    // }
    return Promise.resolve(error.response);
  }
);

function checkStatus(response, showTips) {
  // loading
  // 如果状态码正常，这直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    // if(showTips){
    //   if (response.data.code === 0 && response.data.data&&response.data.data.list && response.data.data.list.length === 0) {
    //     Message.warning('查询条件无对应数据')
    //   }
    // }
    return response.data;
    // 如果不需要data以外的数据直接return response.data
  }
  // 异常状态下，把错误信息返回出去
  let str = '';
  if (!response) {
    str = '';
  } else {
    str = !response.status ? '' : response.status;
  }
  return {
    data: {
      status: str,
      msg: '网络异常'
    }
  };
}

function checkCode(res) {
  // 如果code异常（这里已经包括网络错误，服务器错误，后端抛出错误），可以弹出一个错误提示，告诉用户
  if (res.error === 'error') {
    alert('请求超时');
  }
  return res;
}

export default {
  post(url, data, showTips, callback = function () {
  }) {
    return axios({
      method: 'post',
      baseURI: api.domain, // QA Server
      url: api.domain + url,
      data: data,
      withCredentials: true,
      onUploadProgress: function (progressEvent) {
        if (progressEvent) {
          callback(progressEvent);
        }
      },
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'POST,OPTIONS'
      }
    })
      .then(response => {
        return checkStatus(response, showTips);
      })
      .then(res => {
        return checkCode(res);
      });
  },
  get(url, params) {
    return axios({
      method: 'get',
      baseURI: api.domain, // QA Server
      url: api.domain + url,
      params,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => {
        return checkStatus(response);
      })
      .then(res => {
        return checkCode(res);
      });
  },
  upload(url, data, file, callback = function () { }, useOriname = false, token = '') {
    const promise = new Promise((resolve, reject) => {
      return axios({
        method: 'post',
        baseURI: api.domain,
        url: api.domain + url,
        data: data,
        withCredentials: true,
        onUploadProgress: function (progressEvent) {
          if (progressEvent) {
            callback(progressEvent);
          }
        },
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          'token': token
        }
      }).then(response => {
        // 如果状态码正常，这直接返回数据
        if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
          resolve(response.data.data)
        }
      })
        .catch((res) => {
          reject(res)
        })
    })
    return promise.then((res) => {
      const dataObj = res
      let formData = new FormData()
      let fileName = dataObj.dir + (!useOriname ? random_string() + get_suffix(file.file ? file.file.name : file.raw.name) : (file.file ? file.file.name : file.raw.name));
      formData.append('key', fileName)
      formData.append('policy', dataObj.policy)
      formData.append('OSSAccessKeyId', dataObj.accessid)
      formData.append('success_action_status', '200')
      formData.append('callback', dataObj.callback)
      formData.append('signature', dataObj.signature)
      formData.append('name', file.file.name) // 文件名
      formData.append('file', file.file) // 文件，选择时存在data上
      return axios({
        method: 'post',
        baseURI: dataObj.host, // OSS-upload
        url: dataObj.host,
        data: formData,
        withCredentials: false,
        // onUploadProgress: function(progressEvent) {
        //   if (progressEvent) {
        //     callback(progressEvent);
        //   }
        // },//不考虑进度条问题
        headers: {
          // 'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'POST,OPTIONS'
        }
      })
        .then(subResponse => {
          if (subResponse && (subResponse.status === 200 || subResponse.status === 304 || subResponse.status === 400)) {
            return {
              code: 0,
              data: {
                status: 2000,
                url: fileName,
                prefix: dataObj.prefix,
                msg: '上传成功'
              }
            }
          } else {
            return {
              data: {
                code: 1,
                msg: '网络异常'
              }
            }
          }
        })

    })
  }
};
